export default {
  route: {
    template: 'Leave Feedback - {n}',
    fallback: 'Leave Feedback',
    //dynamic use
    aboutVisit: 'About Visit',
    checkout: 'Checkout',
    digitalReceipt: 'Digital Receipt',
    findVenue: 'Find Venue',
    getStarted: 'Get Started',
    guestReceiptPinEntry: 'Guest Receipt Pin Entry',
    guestTableNumberEntry: 'Table Number Entry',
    index: '',
    listNearbyLocations: 'List Nearby Locations',
    locationCheckIn: 'Location Check In',
    manageTeam: 'Manage Team',
    questions: 'Questions',
    register: 'Register Device',
    recommend: 'Recommend',
    share: 'Share',
    staff: 'Team Member',
    survey: 'Guest Survey',
    tabletCheckIn: 'Tablet Check-In',
    thankYou: 'Thank You',
    teamMemberReceiptPinEntry: 'Team Member Receipt Pin Entry',
    teamMemberTableNumberEntry: 'Team Member Table Number Entry',
    upload: 'Upload',
    error404: '404'
  }
};